import { SVGProps } from 'react';

export const RedoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 0 154 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M149.93 21.9573C155.007 25.0812 155.007 32.4604 149.93 35.5842L116.196 56.3423C110.866 59.6221 104.003 55.7873 104.003 49.5289V8.01263C104.003 1.75419 110.866 -2.08063 116.196 1.1992L149.93 21.9573Z"
        fill="currentColor"
      />
      <path
        d="M103 119.77C103 119.77 82.0024 119.771 79.5024 119.77C77.0024 119.769 113.502 119.771 69.0024 119.771C24.5032 119.771 7.00024 113.771 7 75.2697C6.99976 36.7686 23.5 28.2697 66 28.2697H103"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="round"
      />
    </svg>
  );
};
